import { useSelector } from 'react-redux';

const TAG = '[useTestsSelf]';

/**
 * useTestsSelf - Hook to read self tests from Redux
 * Simple reader - no loading state (handled by TestsLoader)
 * Returns: { tests }
 */
export default function useTestsSelf() {
  const tests = useSelector((s) => s.ovulationTests.selfTests);
  return { tests };
}
